module.exports = __webpack_public_path__ + "static/media/splash3.2a960fc6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/landing/splash3.jpg
// module id = 115
// module chunks = 0